/* tslint:disable */
/* eslint-disable */
/**
 * Public Reply Service
 * Service submit public and query contact information of public replies
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * A geographic direction on the compass
 * @export
 * @enum {string}
 */

export const Aspect = {
    N: 'N',
    Ne: 'NE',
    E: 'E',
    Se: 'SE',
    S: 'S',
    Sw: 'SW',
    W: 'W',
    Nw: 'NW'
} as const;

export type Aspect = typeof Aspect[keyof typeof Aspect];



